export default __webpack_public_path__ + "static/logo-footer-90835130332111dd4a14d446c4f014ea.svg";